import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';
import { AcquisitionTypeList } from '@/shared/lib/sj-orm/models/personalIdentifiersDocuments/dictionaries';
import { omit } from '@/shared/utils/omit';

import { PersonalIdentifierDetails } from '../../sj-orm';
import { TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  commonLegalizedCopiesFields,
  LegalizedCopiesPartType,
  PersonalIdentifierDetailsFormType,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type ResidencePermitGeneralFormType = PersonalIdentifierGeneralFormType;

export const ResidencePermitGeneralSection: ResidencePermitGeneralFormType = {
  ...commonGeneralFields,
};

export type ResidencePermitDetailsDto = Omit<
  PersonalIdentifierDetails,
  'createdAt' | 'updatedAt'
> & {
  idOfficialName?: string;
  cardAccessNumber?: string;
  typeOfPermit?: string;
  acquisitionType?: string;
  residentialAddress?: string;
  workRights?: string;
  limitations?: string;
};

type ResidencePermitDetailsHelp = {
  idOfficialName: QuestionType.TEXT;
  cardAccessNumber: QuestionType.TEXT;
  typeOfPermit: QuestionType.TEXT;
  acquisitionType: QuestionType.SELECT_FROM_LIST;
  residentialAddress: QuestionType.TEXT;
  workRights: QuestionType.TEXT;
  limitations: QuestionType.TEXT;
};

export type ResidencePermitDetailsFormType = Omit<
  PersonalIdentifierDetailsFormType,
  'placeOfBirth'
> &
  TDtoWrapper<ResidencePermitDetailsDto, ResidencePermitDetailsHelp>;

export const ResidencePermitDetailsSection: ResidencePermitDetailsFormType = {
  idOfficialName: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:citizenshipCertificate.inputs.idOfficialName.label',
    value: '',
    capitalized: true,
    order: -1,
  },
  cardAccessNumber: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:residencePermit.inputs.cardAccessNumber.label',
    value: '',
    capitalized: true,
    order: 2,
  },
  typeOfPermit: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:residencePermit.inputs.typeOfPermit.label',
    value: '',
    capitalized: true,
    order: 4,
  },
  acquisitionType: {
    type: QuestionType.SELECT_FROM_LIST,
    items: AcquisitionTypeList,
    label: 'forms_personal_ids:residencePermit.inputs.acquisitionType.label',
    value: '',
    capitalized: true,
    order: 4,
  },
  residentialAddress: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:residencePermit.inputs.residentialAddress.label',
    value: '',
    capitalized: true,
    order: 9,
  },
  workRights: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:residencePermit.inputs.workRights.label',
    value: '',
    capitalized: true,
    order: 9,
  },
  limitations: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:residencePermit.inputs.limitations.label',
    value: '',
    capitalized: true,
    order: 9,
  },
  ...omit(commonDetailsFields, 'placeOfBirth'),
};

export const ResidencePermitLegalizedCopiesSection: LegalizedCopiesPartType = {
  ...commonLegalizedCopiesFields,
};

export const ResidencePermitFormSections = [
  ResidencePermitGeneralSection,
  ResidencePermitDetailsSection,
  ResidencePermitLegalizedCopiesSection,
];
